import { Injectable } from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router} from '@angular/router';

import {EMPTY, Observable} from 'rxjs';
import {catchError, map} from 'rxjs/operators';

import { BusinessService } from '../services/Auth/business.service';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationGuard implements CanActivate {

    constructor(private businessService: BusinessService,
                private router: Router) {
    }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        // Check if logout is in progress - allow it to complete
        const isLoggingOut = localStorage.getItem('logoutRedirect');
        if (isLoggingOut) {
            return true; // Allow navigation to home for logout
        }
        
        var email = localStorage.getItem('email');
        var accessToken = localStorage.getItem('accessToken');
        
        // If on home route (/) without authentication, allow it (for login flow)
        if ((!email || !accessToken) && state.url === '/') {
            return true;
        }
        
        // Check if user has been logged out and trying to access protected route
        if (!email || !accessToken) {
            // Redirect to home page for login
            this.router.navigate(['/']);
            return false;
        }
        
        localStorage.setItem('IsDenied','false');
        // console.log(email);
        // console.log("Test");
        if (!this.businessService.userProfileService.user) {
            return this.businessService
                .userProfileService
                .getUserData(email)
                .pipe(
                    catchError(() => {
                        localStorage.setItem('IsDenied','true');
                        this.router.navigate(['access-denied']);
                        //console.log("Error");
                        return EMPTY;
                    }),
                    map((user) => !!user)
                );
        } else {
            return true;
        }
    }
}
